// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3eFPY","errorLogs":"styles_errorLogs__3rOzF"};